import React, { useState, useEffect } from 'react';
import axios from 'axios';

function DashboardPage({ apiUrl, auth }) {
  const [stats, setStats] = useState(null);
  const [recentRentals, setRecentRentals] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [statsRes, rentalsRes] = await Promise.all([
        axios.get(`${apiUrl}/stats/dashboard`),
        axios.get(`${apiUrl}/rentals`)
      ]);
      setStats(statsRes.data);
      setRecentRentals(rentalsRes.data.slice(0, 15));
    } catch (err) {
      console.error('Erreur:', err);
    }
  };

  if (!stats) return <div className="empty-state"><div className="emoji">⏳</div><div className="text">Chargement...</div></div>;

  return (
    <div>
      <div className="page-header">
        <h1>📊 Tableau de bord</h1>
        <button className="btn btn-outline" onClick={loadData}>🔄 Actualiser</button>
      </div>

      <h3 style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '12px', fontWeight: '600' }}>AUJOURD'HUI</h3>
      <div className="stats-grid">
        <div className="stat-card revenue">
          <div className="stat-label">Recettes</div>
          <div className="stat-value">{stats.today.revenue.toFixed(0)} DA</div>
        </div>
        <div className="stat-card expense">
          <div className="stat-label">Dépenses</div>
          <div className="stat-value">{stats.today.expenses.toFixed(0)} DA</div>
        </div>
        <div className="stat-card profit">
          <div className="stat-label">Bénéfice</div>
          <div className="stat-value">{stats.today.profit.toFixed(0)} DA</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Locations</div>
          <div className="stat-value">{stats.today.rentals}</div>
        </div>
      </div>

      <h3 style={{ fontSize: '14px', color: 'var(--text-secondary)', margin: '24px 0 12px', fontWeight: '600' }}>TOTAL GÉNÉRAL</h3>
      <div className="stats-grid">
        <div className="stat-card revenue">
          <div className="stat-label">Total recettes</div>
          <div className="stat-value">{stats.total.revenue.toFixed(0)} DA</div>
        </div>
        <div className="stat-card expense">
          <div className="stat-label">Total dépenses</div>
          <div className="stat-value">{stats.total.expenses.toFixed(0)} DA</div>
        </div>
        <div className="stat-card profit">
          <div className="stat-label">Bénéfice total</div>
          <div className="stat-value">{stats.total.profit.toFixed(0)} DA</div>
        </div>
      </div>

      <div className="table-wrapper" style={{ marginTop: '24px' }}>
        <div className="table-header">
          <h2>Dernières locations</h2>
        </div>
        <table>
          <thead>
            <tr>
              <th>Ticket</th>
              <th>Articles</th>
              <th>Total</th>
              <th>Employé</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {recentRentals.map(rental => (
              <tr key={rental.id}>
                <td><span className="badge badge-info">#{rental.ticket_number}</span></td>
                <td>{rental.items.map(i => `${i.name} x${i.qty}`).join(', ')}</td>
                <td style={{ fontWeight: '700', color: 'var(--success)' }}>{rental.total.toFixed(0)} DA</td>
                <td>{rental.employee_name || '-'}</td>
                <td style={{ color: 'var(--text-secondary)' }}>
                  {rental.created_at ? new Date(rental.created_at).toLocaleDateString('fr-FR', {
                    day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit'
                  }) : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DashboardPage;
